import { useMutation } from '@tanstack/react-query'
import { ImportQuesitonRes } from '@/types/question.type'
import { axiosInstance } from '@/lib/axios'

interface ReqBodyProps {
  moduleId: string
  file: File
}

interface SaveFileReqBody {
  question_ids_invalid: string[]
  question_file_id: number
  module_id: number
}

export const importQuestionFile = async ({ moduleId, file }: ReqBodyProps) => {
  const formData = new FormData()
  formData.append('module_id', moduleId)
  formData.append('file', file)

  return axiosInstance.post<ImportQuesitonRes>(
    `/question/import-questions`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

export const saveQuestionFile = async ({
  question_file_id,
  question_ids_invalid,
  module_id,
}: SaveFileReqBody) => {
  return axiosInstance.post(`/question/save-question-file`, {
    question_file_id,
    question_ids_invalid,
    module_id,
  })
}

export const useImportQuestionFile = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['importFile'],
    mutationFn: importQuestionFile,
  })

  return { importFileAsync: mutateAsync, isImportingFile: isPending }
}

export const useSaveQuesionFile = () => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['saveQuestionFile'],
    mutationFn: saveQuestionFile,
  })

  return { saveQuestionFileAsync: mutateAsync, isSaving: isPending }
}
